/**
 * Returns the value of `props[path]` or `defaultValue`
 * @example
 * const Button = styled.button`
 *   color: ${prop("color", "red")};
 * `;
 */
export const prop = (path, defaultValue) => (props = {}) => {
    if (typeof props[path] !== 'undefined') {
        return props[path];
    }
    if (path && path.indexOf('.') > 0) {
        const paths = path.split('.');
        const { length } = paths;
        let object = props[paths[0]];
        let index = 1;
        while (object != null && index < length) {
            object = object[paths[index]];
            index += 1;
        }
        if (typeof object !== 'undefined') {
            return object;
        }
    }
    return defaultValue;
};
//# sourceMappingURL=prop.js.map